const GooglePlayIcon = ({ className }: { className: string }) => (
  <svg
    className={`app ${className}`}
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M21.4 12.95L18.62 14.34C18.43 14.44 18.2 14.4 18.04 14.25L16.17 12.38C15.97 12.18 15.97 11.87 16.17 11.67L18.07 9.77002C18.22 9.62002 18.46 9.58002 18.65 9.68002L21.4 11.06C22.19 11.44 22.19 12.56 21.4 12.95Z' />
    <path d='M16.3 8.48996C16.61 8.63996 16.67 9.04998 16.43 9.28998L14.76 10.96L14.05 11.67C13.85 11.87 13.54 11.87 13.34 11.67L6.2 4.52997C5.8 4.12997 6.27 3.47998 6.78 3.72998L16.3 8.48996Z' />
    <path d='M2 20.1501V3.48008C2 3.04008 2.53 2.81007 2.85 3.12007L11.62 11.6301C11.83 11.8301 11.82 12.1601 11.61 12.3601L2.84 20.5201C2.52 20.8201 2 20.5901 2 20.1501Z' />
    <path d='M16.27 15.52L6.88001 20.22C6.37001 20.47 5.90001 19.82 6.30001 19.42L13.35 12.37C13.55 12.17 13.86 12.17 14.06 12.37L16.41 14.72C16.64 14.96 16.57 15.37 16.27 15.52Z' />
  </svg>
)
export default GooglePlayIcon
